var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOcupado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ocupado",
    transform: "translate(-1195 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2633",
    "data-name": "Rectangle 2633",
    transform: "translate(1195 250)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M12.473,8.985h1.5v1.5h-1.5v-1.5M9.481,3h5.237a1.491,1.491,0,0,1,1.5,1.5V14.969h.748v1.5H2v-1.5H7.985V4.5A1.491,1.491,0,0,1,9.481,3m0,1.5V14.969h5.237V4.5Z",
    transform: "translate(1194.519 249.268)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOcupado);
export default __webpack_public_path__ + "static/media/icon-ocupado.b864ebbd8bbaeec907cd98a79ad01796.svg";
export { ForwardRef as ReactComponent };